import { Box } from '@mui/material'
import { FormField, FormRow } from 'src/generated-types/form-field'

export interface IChecklistFieldsLayoutProps {
  layout: FormRow[]
  renderField: (field: FormField, rowIndex: number, fieldIndex: number) => React.ReactNode
  emptyContent?: React.ReactNode
}

export const ChecklistFieldsLayout: React.FC<IChecklistFieldsLayoutProps> = ({ layout, renderField, emptyContent }) => {
  const fields = layout.flatMap((row, rowIndex) =>
    (row.columns ?? []).flatMap((column, colIndex) =>
      (column?.fields ?? []).map((field, fieldIndex) => (
        <Box key={`field-${rowIndex}-${colIndex}-${fieldIndex}`} mb={2}>
          {renderField(field, rowIndex, fieldIndex)}
        </Box>
      )),
    ),
  )

  if (fields.length === 0) return <>{emptyContent ?? null}</>

  return <>{fields}</>
}
